export default {
  Button: {
    Add: 'Thêm',
    Edit: 'Sửa',
    Edit2: 'Chỉnh sửa',
    Edit3: 'Cập nhật',
    Delete: 'Xóa',
    Agree: 'Đồng ý',
    Cancel: 'Hủy bỏ',
    Quit: 'Hủy',
    Close: 'Đóng',
    ChangeAvatar: 'Thay ảnh',
    Create: 'Tạo',
    AcceptAll: 'Xác nhận hết',
    Finish: 'Xong',
    Pricing: 'Định giá',
    View: 'Xem trước',
    Share: 'Chia sẻ',
    Continue: 'Tiếp tục',
    Later: 'Để sau',
    Completed: 'Hoàn tất',
    Save: 'Lưu',
    SaveAndContinue: 'Lưu và tiếp tục',
    SaveDraft: 'Lưu nháp',
    Preview: 'Xem trước',
    Complete: 'Hoàn thành',
    Reject: 'Từ chối',
    Compose: 'Soạn bài',
    AddToExercise: 'Thêm vào đề',
    GoToCart: 'Đi tới giỏ hàng',
    No: 'Không',
    Know: 'Đã hiểu',
    GoToRepository: 'Đi tới kho',
    Back: 'Quay lại',
    DoNotSave: 'Không lưu',
    Approve: 'Phê duyệt',
    StartUse: 'Bắt đầu sử dụng',
    Login: 'Đăng nhập',
    Setting: 'Cài đặt',
    GetAuthCode: 'Lấy mã xác thực',
    Confirm: 'Xác nhận',
    Verification: 'Xác thực',
    CorrectingExercise: 'Chữa bài',
    Copy: 'Sao chép',
    PreviewAndTry: 'Xem & làm thử',
    Try: 'Làm thử',
    Correct: 'Chấm bài',
    Use: 'Sử dụng',
    Choose: 'Chọn',
    ComposeAnswer: 'Soạn đáp án',
    ContinueCompose: 'Tiếp tục soạn',
    CreateSheetAnswer: 'Tạo phiếu đáp án',
    LoginByZalo: 'Đăng nhập bằng Zalo',
    ChooseAnotherFile: 'Chọn đề khác',
    SendRegister: 'Gửi đăng ký',
    StopShare: 'Ngừng chia sẻ',
    CorrectLater: 'Chấm sau',
    CorrectNext: 'Chấm bài tiếp theo',
    Apply: 'Áp dụng',
    RepairExercise: 'Chữa bài ',
    CompleteCorrect: 'Hoàn thành chữa bài',
    EditThread: 'Sửa đề',
    ContinueAnswer: 'Tiếp tục làm',
    ComposeExam: 'Soạn đề kiểm tra',
    CancelChoose: 'Bỏ chọn',
    ChooseAll: 'Chọn tất cả',
    CancelChooseAll: 'Bỏ chọn tất cả',
    Understand: 'Đã hiểu',
    CreateAssessment: 'Tạo kỳ đánh giá',
    Reset: 'Đặt lại',
    Replace: 'Thay thế',
    Detail: 'Chi tiết',
    ComposeThread: 'Soạn đề',
    JoinClass: 'Vào lớp',
    Buying: 'Sử dụng ngay',
    RegistraionStudy: 'Đăng ký học',
    Practice: 'Luyện tập',
    ContinueDoExam: 'Làm bài khác',
    QuestionAnswer: 'Hỏi đáp',
    ExportData: 'Xuất dữ liệu chi tiết',
    ExportReportQuickly: 'Xuất dữ liệu',
    UseNow: 'Sử dụng ngay',
    ContinueGiveExercise: 'Tiếp tục giao bài',
    ViewThread: 'Xem đề bài',
    OverviewAssessment: 'Tổng quan',
    ReLogin: 'Đăng nhập lại',
    NonActive: 'Chưa kích hoạt',
    Trial: 'Dùng thử',
    LoginNow: 'Đăng nhập ngay',
    PasteUrl: 'Gắn đường dẫn',
    Learn: 'Vào học',
    TryLearn: 'Học thử',
    TryLearnStart: 'Bắt đầu học thử',
    ContinueTryLearn: 'Tiếp tục học thử',
    TryLearnLessonFree: 'Học thử bài giảng miễn phí',
    Unlock: 'Mở khóa',
    Assign: 'Giao bài',
    Replay: 'Làm lại',
    Download: 'Tải',
    ChooseFileFromComputer: 'Chọn file từ máy tính',
    PlayNow: 'Chơi ngay',
    Exit: 'Thoát',
    Start: 'Bắt đầu',
    MarkingProgress: 'Tình trạng chấm bài',
    TakeSomethings: 'Nhận',
    ContinuePlay: 'Tiếp tục chơi',
    ChangeFile: 'Đổi file khác',
    CreateGameGalactic: 'Tạo trò chơi',
    ExtractToImage: 'Trích rút thành hình ảnh',
    Send: 'Gửi',
    SaveImage: 'Lưu ảnh',
    Next: 'Để sau',
    // TTLONG
    ViewResult: 'Xem kết quả',
    HistoryDoExercise: 'Lịch sử làm bài',
    ContinueLearn: 'Học tiếp',
    ViewMore: 'Xem thêm',
    SaveAndClose: 'Lưu và đóng',
    SaveAndAdd: 'Lưu và thêm câu',
    Leave: 'Rời đi',
    Sharing: 'Chia sẻ',
    SharingPractice: 'Chia sẻ học liệu',
    AddOtherLink: 'Thêm liên kết khác',
    Collect: 'Sưu tầm',
    Normal: 'Bình thường',
    VeryGood: 'Rất thích',
    SendComments: 'Gửi ý kiến',

    UploadFileFromComputer: 'Tải ảnh từ máy tính',
    ViewNewClass: 'Xem lớp học mới',

    CompensatoryTestList: 'Danh sách bài kiểm tra bù',
    ContinueStudy: 'Tiếp tục học bài'
  }
}
